/**
 * Extract agency label from url.
 * @param {string} url
 * @return {string | null} agency label
 */
export function extractAgencyFromUrl(url) {
  const isAdportal = url.includes('adportal.io');

  if (!isAdportal) {
    return null;
  }

  const parts = url.split('.');
  const subdomain = parts.length > 2 ? parts[0] : null;

  return subdomain;
}
